/**
 * Centralized retry policy for HTTP requests.
 *
 * Only idempotent methods may be retried automatically. Mutations must either
 * declare explicit retryability or fail so the caller can decide what to do.
 */
export function canRetry(config, error) {
  if (!config || !error) {
    return false
  }
  const method = String(config.method || '').toLowerCase()
  if (method !== 'get') {
    return false
  }
  if (config.skipRetry) {
    return false
  }
  const url = String(config.url || '')
  if (!url || url.includes('/health') || url.includes('/auth/')) {
    return false
  }
  return isConnectionError(error)
}

export function isConnectionError(error) {
  if (!error) {
    return false
  }
  return (
    error.message?.includes('Network Error')
    || error.message?.includes('Failed to fetch')
    || error.code === 'ECONNREFUSED'
    || error.message?.includes('ECONNREFUSED')
  )
}
